import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import ReorderIcon from '@mui/icons-material/Reorder'
import ViewDayIcon from '@mui/icons-material/ViewDay'

import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined'
import { Box, Grid, Tab, Tabs, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { selectEventsMenuItem, selectEventView } from '../../../state/events/menu'
import { changeFooterLink } from '../../../state/navigation'
import { pallete } from '../../../theme'
import { isDefined } from '../../../utils'
const sx = {
  container: {
    position: 'sticky',
    zIndex: 100,
    height: '50px',
    top: 0
  },
  tabs: {
    background: pallete.headerTransparentColor,
    '& .Mui-selected': {
      color: `${pallete.paperColor} !important`
    },
    '@media (max-width: 350px)': {
      width: '100% !important',
      minWidth: '100% !important',
      maxWidth: '100% !important'
    }
  },
  controls: {
    height: '50px',
    position: 'sticky',
    lineHeight: '50px',
    textAlign: 'right',
    paddingRight: '10px',
    background: pallete.headerTransparentColor,
    '@media (max-width: 350px)': {
      display: 'none !important'
    },
    '& .MuiToggleButtonGroup-root': {
      display: 'inline-block',
      '& button': {
        background: pallete.headerTransparentColor
      },
      '& button.Mui-selected': {
        background: pallete.headerColor,
        color: pallete.paperColor
      }
    }
  }
}

export const Menu = (props) => {
  const paths = ['/events', '/events/favorite', '/events/assigned']

  const { assignedCount } = props
  const selected = useSelector((state) => state?.eventsMenu?.active?.selected ?? 0)
  const eventView = useSelector((state) => state?.eventsMenu?.view)
  const loggedIn = useSelector((state) => state?.auth?.profile ?? false)
  const dispatch = useDispatch()
  const selectMenuItemDispatcher = (e, value) => {
    dispatch(selectEventsMenuItem({ selected: value, path: paths[value] }))
    dispatch(changeFooterLink({ events: paths[value] }))
  }
  const assigned = (loggedIn && assignedCount > 0) ? (<Tab component={Link} to="/events/assigned" icon={<AssignmentOutlinedIcon />}/>) : undefined

  const handleChange = (event, view) => {
    if (isDefined(view)) {
      dispatch(selectEventView({ view }))
    }
  }

  return (
    <Box sx={sx.container}>
      <Grid container>
        <Grid item xs={8} sx={sx.tabs}>
          <Tabs aria-label="events menu tabs" value={selected} onChange={selectMenuItemDispatcher}>
            <Tab component={Link} to="/events" icon={<CalendarMonthOutlinedIcon />}/>
            <Tab component={Link} to="/events/favorite" icon={<PetsOutlinedIcon />}/>
            {assigned}
          </Tabs>
        </Grid>
        <Grid item xs={4} sx={sx.controls}>
          <ToggleButtonGroup size="small" value={eventView} onChange={handleChange} exclusive={true}>
            <ToggleButton value="day" className="display-day">
              <ViewDayIcon />
            </ToggleButton>
            <ToggleButton value="week" className="display-week">
              <ReorderIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>
    </Box>
  )
}
